<template>
  <div>
    <ProductSelection
      :product="selectProduct(null)"
      :selected="payload"
      :limit="tier.giftsLimit"
      :tier="tier"
      @updateProductVariant="updateProductVariant"
      @handleSelectedItem="product => $emit('handleSelection', product)"
    />
  </div>
</template>

<script>
import Util from '../../mixins/Util'
import { defaultNotFoundImage } from '../../helpers'
import { mapState } from 'vuex'
import ProductSelection from '@/components/Universal/ProductSelection'

export default {
  name: 'ProductPortrait',
  mixins: [Util],
  components: {
    ProductSelection
  },

  props: {
    tier: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    selectedVariants: {
      type: Array,
      required: true
    },
    payload: {
      type: Array,
      default: () => []
    },
    giftsLimit: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      selectedData: state => state.groupOrder.variantSelection
    }),

    isSelected() {
      return !!this.payload.find(item => item.itemId === this.product.itemId)
    }
  },

  watch: {
    // Watch for unselected state on product and set variant to null
    isSelected(val) {
      if (!val) {
        this.selectedData[this.product.itemId] = null
      }
    }
  },

  mounted() {
    this.handleSelect()
  },

  methods: {
    handleSelect() {
      if (this.selectedVariants && this.selectedVariants.length) {
        this.selectedVariants.forEach(variant => {
          const sameProduct = variant.productId == this.product.itemableId
          const sameTier = this.tier.id == variant.tierId

          if (sameProduct && sameTier) {
            // Set the selected product
            this.selectProduct(variant.productVariantId)

            // Get variant from product and set it to selectedData
            const availableProduct =
              this.product.itemableAttributes &&
              this.product.itemableAttributes.product_variants

            const variantInProduct = availableProduct.find(
              item => item.id == variant.productVariantId
            )

            if (variantInProduct) {
              const foundVariant = {
                code: parseInt(variantInProduct.id),
                label: variantInProduct.name.toUpperCase(),
                hasInventory: variantInProduct.available_inventory_count > 0,
                image: variantInProduct.images.length
                  ? variantInProduct.images[0].url
                  : defaultNotFoundImage
              }
              this.updateProductVariant(foundVariant)
            }
          }
        })
      }
    },

    selectProduct(id) {
      const { itemableAttributes } = this.product
      const {
        product_variants,
        default_product_variant_images
      } = itemableAttributes

      const cartProduct = {
        id: this.product.itemId,
        type: 'product',
        itemId: this.product.itemId,
        tierId: this.tier && this.tier.id,
        variantId: id
          ? id
          : product_variants.length == 1
          ? product_variants[0].id
          : null,
        image: default_product_variant_images.length
          ? default_product_variant_images[0].url
          : defaultNotFoundImage,
        name: itemableAttributes.name,
        price: this.tier.showPrices ? itemableAttributes.retail_price : '',
        itemableAttributes
      }
      return cartProduct
    },

    updateProductVariant(data) {
      this.$emit('updateProductVariant', {
        value: data.code,
        itemId: this.product && this.product.itemId
      })
      this.storeVariant(data)
    },

    storeVariant(data) {
      const payload = {
        ...this.selectedData,
        [this.product.itemId]: data
      }
      this.$store.dispatch('groupOrder/persistVariant', payload)
    }
  }
}
</script>
